import { IPOButton } from '../../../styles/components/IPOButton';
import React from 'react';
import { NewsDropdownWrap, OperationDomWrap } from './style';
import { Dropdown } from 'antd';
import downIcon from '../../../images/member-page/down.svg';
interface IOperationProp {
	handleInfoChange: () => void;
	isMessage?: boolean;
	selectData?: {
		seleceKey: string,
		selectLabel: string,
		selectTree: { name: string, id: string }[],
	},
	messageValue?: string,
	handleMesCahnge?: (value: string) => void;
	handelLogInout: () => void;
	messageNodeList?: {
		name: string,
		value: string,
	}[],
}
export const OperationDom = ({ handleInfoChange, messageNodeList, handleMesCahnge, handelLogInout, isMessage = true }: IOperationProp) => {
	const menu = () => {
		return (
			<NewsDropdownWrap>
				{
					messageNodeList && messageNodeList.map(item => {
						return (
							<div className='news-content' key={item.value} onClick={() => {
								console.log(item);
								handleMesCahnge && handleMesCahnge(item.value);
							}}>
								{item.name}
							</div>
						)
					})
				}
			</NewsDropdownWrap>
		)
	}
	return (
		<OperationDomWrap>
			{isMessage &&
				// @ts-ignore
				<Dropdown overlay={menu()} trigger={['click']} getPopupContainer={(node) => node}>
					<div className='news-title'>消息记录通知 <img src={downIcon} alt="" /></div>
				</Dropdown>
			}
			<IPOButton
				type="ghost"
				onClick={handleInfoChange} alt-tip={JSON.stringify({ tit: '可修改个人基本信息', time: 3 })}>
				修改信息
			</IPOButton>
			<IPOButton type="primary" onClick={handelLogInout} alt-tip={JSON.stringify({ tit: '点击可退出系统页面', time: 3 })}>
				退出系统
			</IPOButton>
		</OperationDomWrap>
	);
};


